import { apiClient } from "./ApiClient";

export const fetchRegionPrices = async ({ skip = 0, limit = 20, currency = "USD", location, name } = {}) => {
  const params = { skip, limit, currency };
  if (location) params.location = location;
  if (name) params.name = name;

  const { data } = await apiClient.get("/package/region/prices", { params });
  return data;
};
